import { IconProps } from "../../utils/global-types/global-types";

const TowerIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        d="M12.0716 8.60764C11.893 8.78621 11.893 9.07549 12.0716 9.25406C12.2502 9.43263 12.5394 9.43264 12.718 9.25406C14.7676 7.20451 14.7676 3.86924 12.718 1.81969C12.5395 1.64112 12.2502 1.64112 12.0716 1.81969C11.893 1.99826 11.893 2.28755 12.0716 2.46612C13.7649 4.15942 13.7649 6.91433 12.0716 8.60764Z"
        fill="currentColor"
      />
      <path
        d="M5.28424 9.25589C3.23165 7.20332 3.23165 3.87073 5.28424 1.81817C5.46251 1.63988 5.75051 1.63988 5.9288 1.81817C6.10709 1.99646 6.10709 2.28904 5.9288 2.4673C4.23737 4.15874 4.23737 6.91532 5.9288 8.60673C6.10709 8.78502 6.10709 9.0776 5.9288 9.25589C5.75774 9.42695 5.46608 9.43773 5.28424 9.25589Z"
        fill="currentColor"
      />
      <path
        d="M6.5783 3.1119C6.75659 2.93361 7.04459 2.93361 7.22289 3.1119C7.40118 3.29016 7.40118 3.57817 7.22289 3.76103C6.24459 4.73933 6.24459 6.33475 7.22289 7.31304C7.40118 7.49131 7.40118 7.78389 7.22289 7.96218C7.05182 8.13324 6.76014 8.14401 6.5783 7.96218C5.23887 6.62275 5.23887 4.45132 6.5783 3.1119Z"
        fill="currentColor"
      />
      <path
        d="M10.7797 7.31304C11.758 6.33475 11.758 4.73933 10.7797 3.76103C10.6014 3.57817 10.6014 3.29016 10.7797 3.1119C10.958 2.93361 11.246 2.93361 11.4243 3.1119C12.7637 4.45132 12.7637 6.62275 11.4243 7.96218C11.2423 8.14415 10.9506 8.13312 10.7797 7.96218C10.6014 7.78389 10.6014 7.49131 10.7797 7.31304Z"
        fill="currentColor"
      />
      <path
        d="M13.0836 15.6879L9.62305 7.01132C10.1991 6.76447 10.6013 6.19762 10.6013 5.53933C10.6013 4.65705 9.88363 3.93933 9.00134 3.93933C8.11903 3.93933 7.40134 4.65705 7.40134 5.53933C7.40134 6.19762 7.8036 6.76447 8.37961 7.01132L4.91903 15.6879C4.82763 15.921 4.94191 16.1862 5.17503 16.2822C5.40818 16.3782 5.67333 16.2593 5.76934 16.0262L5.82877 15.8707L9.00134 13.1142L12.1693 15.8707L12.2333 16.0262C12.3359 16.2763 12.6146 16.3709 12.8276 16.2822C13.0607 16.1862 13.175 15.921 13.0836 15.6879ZM6.56934 14.0148L7.46532 11.7748L8.30648 12.5062L6.56934 14.0148ZM7.82191 10.8742L9.00134 7.91648L10.1808 10.8742L9.00134 11.8982L7.82191 10.8742ZM9.69618 12.5062L10.5373 11.7748L11.4333 14.0148L9.69618 12.5062Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TowerIcon;
